import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconHelpbook = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_300_3450)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M7.26562 0.46875V5.625L5.625 4.6875L3.98438 5.625V0.46875M1.64062 13.3594C1.64063 13.6702 1.76409 13.9682 1.98386 14.188C2.20363 14.4078 2.5017 14.5312 2.8125 14.5312H12.1875C12.4983 14.5312 12.7964 14.4078 13.0161 14.188C13.2359 13.9682 13.3594 13.6702 13.3594 13.3594V11.25M1.64062 13.3594V1.64062C1.64063 1.32982 1.76409 1.03175 1.98386 0.811984C2.20363 0.592215 2.5017 0.46875 2.8125 0.46875H12.1875C12.4983 0.46875 12.7964 0.592215 13.0161 0.811984C13.2359 1.03175 13.3594 1.32982 13.3594 1.64062V11.0156C13.3594 11.3264 13.2359 11.6245 13.0161 11.8443C12.7964 12.064 12.4983 12.1875 12.1875 12.1875H2.8125C2.5017 12.1875 2.20363 12.311 1.98386 12.5307C1.76409 12.7505 1.64063 13.0486 1.64062 13.3594Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_300_3450",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 15,
			height: 15,
			fill: "currentColor"
		})
	}) })]
});
export default SvgIconHelpbook;
